import {
  type GetDataIngestionSourcesRequest,
  type GetDataIngestionSourcesResponse,
  type ModuleId,
} from '../../types';
import { getDatasetAgeDays } from '../utilities/get-dataset-age-days';
import { getDatasetFreshnessStatus } from '../utilities/get-dataset-freshness-status';
import { getKnownSources } from '../utilities/get-known-sources';

import {
  getBatchAndOverallDatasetsFreshnessStatus,
  getNewerDatasets,
  MODULE_TO_RELEVANT_DATA_SOURCES_MAP,
} from './utilities';

export const getBatchDataFreshness = (
  response: GetDataIngestionSourcesResponse,
  moduleId: ModuleId,
  batchCreatedAt?: string,
) => {
  const knownSources = getKnownSources(response.sources);
  const relevantSources = knownSources.filter((source) => {
    const moduleSources = MODULE_TO_RELEVANT_DATA_SOURCES_MAP[moduleId];
    return moduleSources.includes(source.name);
  });

  const datasets = relevantSources.map((source) => ({
    ...source,
    ageDays: getDatasetAgeDays(source.updated_at),
    status: getDatasetFreshnessStatus(getDatasetAgeDays(source.updated_at)),
  }));

  const oldDatasets = datasets.filter((dataset) => dataset.status !== 'new');

  const datasetsNewerThanBatch = getNewerDatasets(datasets, batchCreatedAt);

  return {
    status: getBatchAndOverallDatasetsFreshnessStatus(datasets, batchCreatedAt),
    datasets,
    old_datasets: oldDatasets,
    datasets_newer_than_batch: datasetsNewerThanBatch,
  };
};

export type GetBatchDataFreshnessResponse = ReturnType<
  typeof getBatchDataFreshness
>;

export type GetBatchDataFreshnessRequest = Omit<
  GetDataIngestionSourcesRequest,
  'query'
> & {
  query: {
    module_id: ModuleId;
    batch_created_at?: string;
  };
};
